export { SpaDaysCategoryV2Connected as SpaDaysCategoryV2 } from './container';
